import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import * as GQL from '~/graphql/generated/client';

interface Props {
  className?: string;
  organizations: GQL.AnchOrganizationUnit[];
  selectedOrganizationId: number | null;
  onOrganizationChange: (organizationId: number) => void;
  disabled?: boolean;
}

const OrganizationSelectorImpl: React.FC<Props> = ({
  className,
  organizations,
  selectedOrganizationId,
  onOrganizationChange,
  disabled = false,
}) => {
  // Filter out "Default OU" from the dropdown options
  const filteredOrganizations = organizations.filter(
    (org) => org.name !== 'Default OU'
  );

  return (
    <FormControl className={className} disabled={disabled}>
      <InputLabel id="organization-selector-label">
        Select Organization
      </InputLabel>
      <Select
        labelId="organization-selector-label"
        id="organization-selector"
        value={selectedOrganizationId ?? ''}
        label="Select Organization"
        onChange={(e) => onOrganizationChange(Number(e.target.value))}
      >
        {filteredOrganizations.map((org) => (
          <MenuItem key={org.id} value={org.id}>
            {org.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const OrganizationSelector = muiStyled(OrganizationSelectorImpl)(
  ({ theme }) => css`
    min-width: 250px;
    max-width: 300px;
    margin-bottom: ${theme.spacing(2)};
  `
);

export default OrganizationSelector;
